import { Checkbox } from '@amzn/stencil-react-components/checkbox';
import { Col, Spacer, View } from '@amzn/stencil-react-components/layout';
import { Label } from '@amzn/stencil-react-components/text';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { deleteCampaignSection, updateJourneyChannel } from '../../actions/journeyDetailsAction';
import { ChannelType } from '../../enums/schedulingConstant';
import { journeyDetailsCampaignsSelector } from '../../selectors/selectors';

import { IconCrossInsideCircleSmall } from '@amzn/stencil-react-icons';

const ChannelTypeForm = ({ channelData, id, readonly }) => {
  const dispatch = useDispatch();
  const campaigns = useSelector(journeyDetailsCampaignsSelector);

  const deleteJourneyCampaign = () => {
    dispatch(deleteCampaignSection(id));
  };

  const onChannelTypeChange = (e, value) => {
    const updatedData = {
      channel: e.target.checked ? value : '',
    };
    dispatch(updateJourneyChannel(id, updatedData));
  };
  return (
    <>
      <Col key={`channel-form-${id}`} gridGap="S200">
        <Col display="flex" flexDirection="row" alignItems="center">
          <View width="90%">
            <Label fontSize="T300" fontWeight="bold">
              <FormattedMessage id="app.channelTypeForm.label.platform" defaultMessage="Platform" />
            </Label>
          </View>
          <View
            className={campaigns.length === 1 ? 'disabled' : ''}
            color="primary"
            disabled={readonly}
            data-testid="delete-icon"
            style={{ cursor: 'pointer' }}
            onClick={deleteJourneyCampaign}
          >
            <IconCrossInsideCircleSmall />
          </View>
        </Col>
        <View display="flex" alignItems="center">
          <Checkbox
            disabled={readonly}
            key={`channel-type-once-${id}`}
            id="email-channel"
            data-testid="email-channel-field"
            checked={channelData?.channel === ChannelType.EMAIL}
            onChange={e => onChannelTypeChange(e, ChannelType.EMAIL)}
          />
          <Spacer width={10} />
          <Label key={`channel-once-label-${id}`} htmlFor="email-channel">
            EMAIL
          </Label>
        </View>
      </Col>
    </>
  );
};

export default ChannelTypeForm;
